export default __webpack_public_path__ + "static/media/73.b8b6c56c.jpg";